export default __webpack_public_path__ + "static/media/photo2.ee8a3318.jpg";